import { cancel, get, post } from '@zoom/billing-axios';
import qs from 'qs';

export const getEssentialAppList = (page = 1, size = 50) =>
  get(`/marketplace/essential_apps?page_size=${page}&page_num=${size}`)();

export const fetchPricingPlanMap = get('/billing/basic/plan', { isC25Plan: 1 });

export const fetchPriceFromZuora = get('/pricing/planPrice.json');

export const fetchPricingPlanList = get('/billing/plan/list', { listCPaas: true });

export const fetchBasicConfig = get('/billing/basic/config');

export const reactivatePlan = post('/billing/plan/reactivate');
export const reactivateSubPlan = post('/billing/plan/reactivate_subplan');
export const billingEventPolling = get('/billing/event/status');
export const cancelBillingEventPolling = cancel('/billing/event/status')

export const fetchBadgeConfigs = get('/billing/basic/badge_list');

export const fetchVendorsProducts = get('/billing/ecomm/seller/product/list');

export const TaxECM = {
  // for multiple billing or split billing account
  _bid: (() => {
    const search = qs.parse(location.search.replace(/^\?/, ''))
    return search?.bid ?? ''
  })(),
  fetch() {
    const fetchUrl = '/billing/ecm/certificates' + (this._bid ? `?bid=${this._bid}` : '')
    return get(fetchUrl)()
  },
  setDefault(body) {
    const postUrl = '/billing/ecm/certificate/default' + (this._bid ? `?bid=${this._bid}` : '')
    const bodyData = Object.assign({}, body)
    if (this._bid) {
      Object.assign(bodyData, { bid: this._bid })
    }
    return post(postUrl, true)(bodyData)
  }
};
